import DialogBase from "../libs/DialogBase";

let googleMapsPromise = null;

const loadGoogleMapsApi = () => {

    if (window.google?.maps) {
        return Promise.resolve();
    }

    if (googleMapsPromise) {
        return googleMapsPromise;
    }

    googleMapsPromise = new Promise((resolve) => {
      window.mapReady = resolve;
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${LtikeCommon.GOOGLE_MAP_API_KEY}&loading=async&callback=mapReady`;
      script.async = true;
      document.head.appendChild(script);
    });

    return googleMapsPromise;
};

export default class DialogMap extends DialogBase {
  constructor() {
    super("#dialog_map");

    const el = document.querySelector('.js-dialog_map');
    el.addEventListener('click', async (e) => {
      await this.initializeMap();
      this.onOpen();
    });

  }

  makeMap(zoom, lat, lng, target, disableDefaultUI = true) {
    const canvas = target; // 地図を表示する要素を取得
    const latlng = new google.maps.LatLng(lat, lng);  // 中心の位置（緯度、経度）

    // マップのオプション
    const mapOptions = {
      zoom: zoom, // ズームレベル
      center: latlng, // 中心点緯度経度
      scaleControl: true, // 距離目盛りの表示
      fullscreenControl: false, // 全画面ビューボタンの表示
      disableDefaultUI: disableDefaultUI
    };
    const myMap = new google.maps.Map(canvas, mapOptions); //作成

    const myMarker = new google.maps.Marker({
      // マーカーを置く緯度経度
      position: new google.maps.LatLng(lat, lng),
      map: myMap
    });
  }

  async initializeMap() {

    await loadGoogleMapsApi();

    document.querySelectorAll('.js-map_embed').forEach(el => {
      if (el.dataset.mapInitialized === 'true') {
        return;
      }

      const isDialog = el.closest('.dialog_map');
      this.makeMap(
        Number(el.dataset.zoom),
        Number(el.dataset.lat),
        Number(el.dataset.lng),
        el,
        isDialog === null
      );

      el.dataset.mapInitialized = 'true';
    });
  }
}
